import { createSelector } from "reselect";

import { SaleStatus } from "constants/sale";

import { getSaleStatuses } from "../root";

// Exclude the read-only Reference status from the management grid.
export const selectSaleStatusesAggridData = createSelector(
  [getSaleStatuses],
  (saleStatusesByIdLookup: Record<string, SaleStatus>) =>
    Object.values(saleStatusesByIdLookup).filter(
      saleStatus => saleStatus.archetype !== SaleStatus.REFERENCE,
    ),
);
